var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17q-.625 0-1.062-.448Q3 16.104 3 15.5v-11q0-.604.438-1.052Q3.875 3 4.5 3h11q.625 0 1.062.448Q17 3.896 17 4.5v11q0 .604-.438 1.052Q16.125 17 15.5 17Zm0-1.5h11v-11h-11v11Zm1-1.5h9l-3-4-2.25 3-1.5-2Zm-1 1.5v-11 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.6f687953.svg";
export { ForwardRef as ReactComponent };